import { PlessJsonUploadServiceSub } from 'src/app/commons/kymw00/pless-json-upload-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 按分比率取込を行うサービス
 *
 * @export
 * @class ImportDistributionRatioService
 * @extends {PlessJsonUploadServiceSub}
 */
@Injectable()
export class ImportDistributionRatioService extends PlessJsonUploadServiceSub<any> {

  private nextFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof ImportDistributionRatioService
   */
  execute(file: File, nextFunc: Function): void {
    this.nextFunc = nextFunc;
    this.sendFile('importDistributionRatio', new PlessRequest(), file);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof ImportDistributionRatioService
   */
  success(data: any) {
    this.nextFunc(data);
  }
}
